(function () {
  'use strict';

  /* ---------- Bundle / variant selection ---------- */
  var grid = document.getElementById('bundleGrid');
  if (grid) {
    var btnPrice = document.getElementById('bundleBtnPrice');
    var bbPrice = document.getElementById('bbPrice');
    var bbVariant = document.getElementById('bbVariant');

    function sync(label) {
      if (!label) return;
      grid.querySelectorAll('.bundle').forEach(function (b) { b.classList.remove('sel'); });
      label.classList.add('sel');
      var price = label.getAttribute('data-price') || '';
      var qtyEl = label.querySelector('.qty');
      var title = qtyEl ? qtyEl.textContent.trim() : '';
      if (btnPrice) btnPrice.textContent = price;
      if (bbPrice) bbPrice.textContent = price;
      if (bbVariant) bbVariant.textContent = title;
    }

    grid.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        sync(e.target.closest('.bundle'));
      }
    });

    // init from the pre-selected card
    sync(grid.querySelector('.bundle.sel') || grid.querySelector('.bundle'));
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq').forEach(function (f) {
    var btn = f.querySelector('button');
    var ans = f.querySelector('.ans');
    if (!btn || !ans) return;
    btn.addEventListener('click', function () {
      var open = f.classList.contains('open');
      document.querySelectorAll('.faq').forEach(function (x) {
        x.classList.remove('open');
        var a = x.querySelector('.ans');
        if (a) a.style.maxHeight = null;
      });
      if (!open) {
        f.classList.add('open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Sticky buy bar ---------- */
  var buybar = document.getElementById('buybar');
  var bundles = document.getElementById('bundles');
  if (buybar && bundles) {
    var onScroll = function () {
      var r = bundles.getBoundingClientRect();
      var bundleVisible = r.top < window.innerHeight && r.bottom > 0;
      var nearFooter = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 240);
      if (window.scrollY > 700 && !bundleVisible && !nearFooter) {
        buybar.classList.add('show');
      } else {
        buybar.classList.remove('show');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
